<template>
    <svg
        class="icon book"
        height="24"
        width="24"
        viewBox="0 0 24 24"
    >
        <path d="M12,5.9C6.9,3.7,2.3,4.1,2,4v16c0,0,5-0.4,10,2.1c5-2.5,10-2.1,10-2.1V4C21.7,4.1,17.1,3.7,12,5.9z M11,19.5c-1.5-0.6-4-1.3-7-1.5V6c3.2,0.2,5.9,1.2,7,1.6V19.5z M20,18c-3,0.1-5.5,0.9-7,1.5V7.7c1.1-0.5,3.8-1.4,7-1.6V18z" />
    </svg>
</template>

<script>
export default {}
</script>